export const PAGE_FEATURES: Record<string, { label: string; features: { id: string; label: string }[] }> = {
  clubNews: { label: 'Club Nieuws', features: [{ id: 'manage', label: 'Beheren' }] },
  events: { label: 'Events', features: [{ id: 'edit', label: 'Aanpassen' }] },
  media: { label: 'Media', features: [{ id: 'upload', label: 'Uploaden' }] },
  profile: { label: 'Profiel', features: [{ id: 'edit', label: 'Wijzigen' }] },
  team: { label: 'Team', features: [{ id: 'manage', label: 'Beheren' }] }
};
